import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  constructor(private readonly router: Router) {
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((event: NavigationStart) => {
      if (event.navigationTrigger === 'popstate') {
        localStorage.setItem('user_nav_history', JSON.stringify(true));
      } else {
        localStorage.setItem('user_nav_history', JSON.stringify(false));
      }
    });
  }
}
